import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, createSlots as _createSlots, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header border-0 pt-6" }
const _hoisted_3 = { class: "card-title align-items-center d-flex flex-wrap" }
const _hoisted_4 = { class: "card-label" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "card-toolbar" }, null, -1)
const _hoisted_6 = { class: "card-body pt-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Datatable = _resolveComponent("Datatable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h1", _hoisted_4, _toDisplayString($setup.breadcrumbs[1][$setup.breadcrumbs[1].length - 1]), 1)
      ]),
      _hoisted_5
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_Datatable, {
        ref: "tableRef",
        "table-header": $setup.tableHeader,
        "table-data": _ctx.tableData,
        loading: _ctx.loading,
        total: _ctx.total
      }, _createSlots({
        "cell-no": _withCtx(({ index }) => [
          _createTextVNode(_toDisplayString(index + 1 + _ctx.rowsPerPage * (_ctx.currentPage - 1)), 1)
        ]),
        "cell-usedCoupon": _withCtx(({ row }) => [
          _createTextVNode(_toDisplayString(`${row.used}/${row.quantity}`), 1)
        ]),
        _: 2
      }, [
        _renderList($setup.tableHeader.filter(
            (data) => !['usedCoupon'].includes(data.key)
          ), (item, i) => {
          return {
            name: `cell-${item.key}`,
            fn: _withCtx(({ row }) => [
              _createElementVNode("div", null, _toDisplayString(row[`${item.key}`]), 1)
            ])
          }
        })
      ]), 1032, ["table-header", "table-data", "loading", "total"])
    ])
  ]))
}